import { useState } from "react";
import type { DeepRequired, FieldErrors, FieldErrorsImpl, FieldValues } from "react-hook-form";

import { useLayoutStore } from "@store/layout";

export default function useFormErrorHandler<T extends FieldValues>({
  values,
  errors,
  keyOrders,
}: {
  values: T;
  errors?: Partial<FieldErrorsImpl<DeepRequired<T>>>;
  keyOrders?: string[];
}) {
  const { openToast } = useLayoutStore();

  const [firstErrorKey, setFirstErrorKey] = useState<T[keyof T]>();

  // firstErrorKey 지정해야되는 경우
  const onCommonError = (error: FieldErrors<T>): void => {
    const sortedKeys = keyOrders ? ["country"].concat(keyOrders) : Object.keys(values);

    sortedKeys.some((key) => {
      if (error[key as keyof T]) {
        setFirstErrorKey(key as T[keyof T]);
        return true;
      }

      return false;
    });
  };

  // 에러 토스트만 띄우는 경우
  const onCommonErrorMessage = (error: FieldErrors<T>): void => {
    const errorMessage = Object.values(error)[0]?.message || "";
    if (errorMessage) openToast({ message: errorMessage as string });
  };

  const displayError = (key: T[keyof T]) => {
    if (!errors || !Object.keys(errors).length) return;

    return {
      isError: firstErrorKey === key,
      errorMessage: firstErrorKey === key ? errors[key as keyof typeof errors]?.message : "",
    };
  };

  return { firstErrorKey, setFirstErrorKey, onCommonError, onCommonErrorMessage, displayError };
}
